import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-ChangeOwnershipRescission',
    templateUrl: './ChangeOwnershipRescission.component.html',
    styleUrls: ['./ChangeOwnershipRescission.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ChangeOwnershipRescissionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
